import { Link } from 'react-router-dom'

/**
 * Fallback UI when the app hits a React error boundary.
 * Shown instead of a blank screen; no PII.
 */
function ErrorBoundaryFallback() {
  return (
    <div
      className="error-boundary-fallback"
      role="alert"
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Something went wrong</h1>
      <p style={{ color: 'var(--text-subtle)', marginBottom: '1.5rem', maxWidth: 360 }}>
        We’ve been notified and are looking into it. Please try again or go back to the home page.
      </p>
      <Link className="primary-button" to="/">
        Go to home
      </Link>
    </div>
  )
}

export default ErrorBoundaryFallback
